module.exports = __webpack_public_path__ + "static/img/me.a046d78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/me.png
// module id = TN3P
// module chunks = 0